module.exports = "/remote-dist/e644892a9185aa933e599bba25353617.gif";